import SlButton from "@shoelace-style/shoelace/dist/react/button";
import SlIcon from "@shoelace-style/shoelace/dist/react/icon";
import SlInput from "@shoelace-style/shoelace/dist/react/input";
import { KeyboardEvent, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import ditellaBg from "../../assets/ditella-bg.jpg";
import logo from "../../assets/ditella-logo.png";
import "./Login.css";

import { CredentialResponse, GoogleLogin } from "@react-oauth/google";
import SlSpinner from "@shoelace-style/shoelace/dist/react/spinner";
import { jwtDecode } from "jwt-decode";
import { useAppDispatch } from "../../app/store";
import useAuth from "../../hooks/useAuth";
import { selectAuthenticated } from "../../features/Dashboard/Slices/userSlice";
import { useSelector } from "react-redux";
const pjson = require("../../../package.json");

const Login = () => {
  const isDevEnv =
    process.env.REACT_APP_ENV === "Dev" ||
    process.env.REACT_APP_ENV === "Testing" ||
    process.env.REACT_APP_ENV === "Localhost";
  const version = `-v ${pjson.version}`;

  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const navigate = useNavigate();
  const [logingIn, setLogingIn] = useState(false);
  const dispatch = useAppDispatch();
  const isAuthenticated = useSelector(selectAuthenticated);

  const handleKeyDown = (event: KeyboardEvent<HTMLFormElement>) => {
    if (event.key === "Enter") {
      event.preventDefault();
    }
  };


  const handleInput = (e: any) => {
    if (e?.target?.value) {
      setEmail(e?.target?.value);
    }
  };

  const handleGoogleLogin = async (res: CredentialResponse) => {
    setLogingIn(true);
    const decoded: any = jwtDecode(res.credential || "");
    if (decoded?.email) {
      login(decoded?.email);
    }
  };

  useEffect(() => {
    if (isAuthenticated) {
      navigate("/home");
    }
  }, [isAuthenticated]);

  return (
    <div className="login-page">
      <div className="form-login-btn">
        <img src={logo} alt="logo Ditella" width={150} />
        <h1>UTDT Backoffice</h1>
        <p>Identifíquese usando su cuenta autorizada</p>
        {isDevEnv && (
          <form onKeyDown={handleKeyDown}>
            <div className="row">
              <SlInput
                name="email"
                value={email}
                onSlInput={handleInput}
                required
              />
              <SlButton
                size="medium"
                type="button"
                onClick={() => login(email)}
                disabled={logingIn}
                loading={logingIn}
              >
                <SlIcon slot="prefix" name="box-arrow-in-right"></SlIcon>
              </SlButton>
            </div>
          </form>
        )}
        {!logingIn ? (
          <GoogleLogin
            locale="es"
            onSuccess={(credentialResponse: CredentialResponse) => {
              handleGoogleLogin(credentialResponse);
            }}
            onError={() => {
              console.log("Login Failed");
              alert("Login Failed");
            }}
          />
        ) : (
          <SlSpinner />
        )}
        <p>{version}</p>
      </div>
      <img src={ditellaBg} alt="" />
    </div>
  );
};

export default Login;
